import { fetchBehavior as fetchBehaviorFromApi } from '@/api/proxy'
import { fiveMinutesPolicyHasExpired } from '@/utils/cachePolicies'

/**
* Fetch user behavior from API
*/
const fetchBehavior = async ({ commit }) => {
  let response = await fetchBehaviorFromApi()
  commit('SET_BEHAVIOUR', response)
}

/**
* Load user behavior.
* If cache is empty or stale fetch it from API
*/
const loadBehavior = async ({ dispatch, state }) => {
  if (fiveMinutesPolicyHasExpired(state.created)) {
    await dispatch('fetchBehavior')
  }
}

export default {
  fetchBehavior,
  loadBehavior
}



// WEBPACK FOOTER //
// ./src/store/modules/user/behavior/actions.js